import React from 'react';
import Slider from 'react-slick'; // Importando o Slider do react-slick
import '../../styles/carrossel.css'; // Estilo do carrossel
// Exemplo de imagens para o carrossel (substitua com suas próprias imagens)
import PsicoTcc from '../../img/header/psetcc.webp';
import psicologiaSistemica from '../../img/especialidadesImagens/psicoSistemica.webp';
import PsicoHuma from "../../img/especialidadesImagens/psicoHuma.webp";
import { Link } from 'react-router-dom';

const Carrossel: React.FC = () => {
  const settings = {
    dots: true, // Mostra os pontos de navegação
    infinite: true, // O carrossel será infinito
    speed: 500, // Velocidade da transição
    slidesToShow: 3, // Exibe três itens por vez por padrão
    slidesToScroll: 1, // Desliza 1 item por vez
    responsive: [
      {
        breakpoint: 1024, // Para telas menores que 1024px
        settings: {
          slidesToShow: 2, // Exibe 2 itens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // Para telas menores que 768px
        settings: {
          slidesToShow: 2, // Exibe 1 item por vez
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // Para telas menores que 480px
        settings: {
          slidesToShow: 1, // Exibe 1 item por vez
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="carousel-container">
      <h2 className="clinica_especialidades">Especialidades</h2>

      <Slider {...settings}>

        {/* Psico Sistemica */}
        <Link to="/especialidade/psicologiaSistemica" className="carousel-item">
          <div className='carousel-espacamento'>
            <div
              className="carousel-image"
              style={{ backgroundImage: `url(${psicologiaSistemica})` }}
            >
              <div className="carousel-overlay" />
              <p>Psicologia Sistêmica</p>
            </div>
          </div>
        </Link>

        {/* PsicoTcc */}
        <Link to="/especialidade/psicologiatcc" className="carousel-item">
          <div className='carousel-espacamento'>
            <div
              className="carousel-image"
              style={{ backgroundImage: `url(${PsicoTcc})` }}
            >
              <div className="carousel-overlay" />
              <p>Piscologia TCC</p>
            </div>
          </div>
        </Link>

          {/* PsicoHumanista */}
        <Link to="/especialidade/psicoHumanista" className="carousel-item">
          <div className='carousel-espacamento'>
            <div
              className="carousel-image"
              style={{ backgroundImage: `url(${PsicoHuma})` }}
            >
              <div className="carousel-overlay" />
              <p>Psicologia Humanista</p>
            </div>
          </div>
        </Link>

      </Slider>
    </div>
  );
};

export default Carrossel;
